import React from 'react';
import { Image, Feature, Stat } from '../../../types/cards';
import './InformContent.css';

interface InformSelectorProps {
    image: Image;
    title: string;
    description: string;
    features: Feature[];
    stats: Stat[];
    buttonText: string | null;
    onContinue: () => void;
    step: any;
}

export const InformContent: React.FC<InformSelectorProps> = ({
    image,
    title,
    description,
    buttonText,
    onContinue
}) => {
    const imageUrl = image.url;

    return (
        <div
            className="inform-selector__wrapper"
        >
            <div className="inform-selector">
                {imageUrl && (
                    <div className="inform-selector__image-container">
                        <img
                            src={imageUrl}
                            alt={image.alternativeText || 'Info illustration'}
                            className="inform-selector__image"
                        />
                    </div>
                )}
                <div className="inform-selector__content">
                    <h2 className="inform-selector__title">{title}</h2>
                    <p className="inform-selector__description">{description}</p>
                </div>
            </div>
            {buttonText && (
                <div className="inform-selector__button-fixed">
                    <button
                        className="inform-selector__button"
                        onClick={onContinue}
                    >
                        {buttonText}
                    </button>
                </div>
            )}
        </div>
    );
};
